export default "__VITE_ASSET__f62fe890__"